import axiosInstance from "./axiosInstance";

export interface VenueSchedule {
  tourVenueScheduleId: number;
  publicId: string;
  tourId: number;
  venueId: number;
  venueName: string;
  checkInDate: string;
  checkInTime: string;
  checkOutDate: string;
  checkOutTime: string;
}

export interface RoomAvailabilityRoom {
  roomSelectionPublicId: string;
  propertyRoomTypeId: number;
  roomTypeName: string;
  minCapacity: number;
  maxCapacity: number;
  requestedNumber: number;
  roomAllocated: number;
}

export interface RoomAvailabilityProperty {
  propertyId: number;
  propertyName: string;
  rooms: RoomAvailabilityRoom[];
}

export interface RoomAvailability {
  venueId: number;
  venueName: string;
  checkInDate: string;
  checkOutDate: string;
  properties: RoomAvailabilityProperty[];
}

export interface TourAvailabilityRecommendation {
  id: number;
  tourId: number;
  requestedStartDate: string;
  requestedEndDate: string;
  isAvailable: boolean;
  reason: string;
  acceptedAt: string | null;
  recommendedOn: string;
}

export interface RoomAllocationApplicant {
  tourRoomAllocationApplicantId: number;
  publicId: string;
  tourRoomAllocationId: number;
  visaApplicationId: number;
  itsNo: string;
  applicantName: string;
  isActive: boolean;
}

export interface RoomAllocation {
  tourRoomAllocationId: number;
  publicId: string;
  roomSelectionPublicId: string;
  venueName: string;
  propertyName: string;
  roomTypeName: string;
  minCapacity: number; 
  maxCapacity: number;
  minAdults: number;
  maxAdults: number;
  maxChildren: number;
  roomAllocated: number;
  status: string;
  isActive: boolean;
  applicants: RoomAllocationApplicant[];
}

export interface TourApprovalResponse {
  tourId: number;
  publicId: string;
  tourName: string;
  tourType: number;
  tourCategory: number;
  rotationId: number | null;
  rotationName: string | null;
  tourOperatorId: number;
  tourOperatorName: string;
  noOfApplicants: number;
  faizAccommodation: boolean;
  accommodationPreference: string | null;
  specialAccommodationRequest: string | null;
  notes: string | null;

  arrivalTransportMode: number;
  arrivalFlightNo: string;
  arrivalTime: string;
  arrivalPortId: number;
  arrivalPortName: string;
  arrivalDate: string;
  arrivalBookingRef: string;
  arrivalAirline: string;

  departureTransportMode: number;
  departureFlightNo: string;
  departureTime: string;
  departurePortId: number;
  departurePortName: string;
  departureDate: string;
  departureBookingRef: string;
  departureAirline: string;

  isArrivalConfirmed: boolean;
  isDepartureConfirmed: boolean;

  status: number;
  approvalStatus: number;
  isActive: boolean;

  createdBy: number;
  createdAt: string;
  updatedBy: number | null;
  updatedAt: string | null;

  venueSchedules: VenueSchedule[];
  roomAvailabilities: RoomAvailability[];
  roomAllocations: RoomAllocation[];
  tourAvailabilityRecommendations: TourAvailabilityRecommendation[];
}

export interface VisaApplicantQuery {
  searchText?: string | null;
  applicationNumber?: string | null;
  applicantName?: string | null;
  itsNo?: string | null;
  passportNo?: string | null;
  nationality?: string | null;
  visaRequired?: boolean | null;
  createdFrom?: string | null;
  createdTo?: string | null;
}

export interface ApprovalHistory {
  approvalHistoryId: number;
  documentVersionId: number;
  historyStatus: string;
  remarks: string;
  actionBy: number;
  actionAt: string;
}

export interface DocumentVersion {
  documentVersionId: number;
  documentId: number;
  versionNo: number;
  fileName: string;
  filePath: string;
  documentVersionStatus: string;
  documentVersionRemarks: string;
  histories: ApprovalHistory[];
}

export interface VisaDocument {
  documentId: number;
  moduleCode: string;
  documentMasterId: number;
  entityId: number;
  status: string;
  isActive: boolean;
  documentCode: string;
  documentName: string;
  screens: string;
  acceptedFormats: string;
  isMandatory: boolean;
  maxFileSizeKB: number;
  description: string;
  expireMaxLimit: number;
  versions: DocumentVersion[];
}

export interface VisaApplication {
  visaApplicationId: number;
  tourOperatorId: number;
referenceId?:string;
  toitsNumber: string;
  toFirstName: string;
  toMiddleName: string;
  toLastName: string;
  toFullName: string;
  toOfficeName: string;
  toOfficeNumber: string;
  toBusinessType: string;
  toArabicName: string;

  ejamaatId: string;

  itsNo: string;
  isNonItsUser: boolean;

  applicantType: string;
  category: string;

  guardianITS: string;
  hofITS: string;

  title: string;

  applicationNumber: string;

  firstName: string;
  middleName: string;
  lastName: string;

  dateOfBirth: string;
  age: number;
  gender: string;
  birthPlace: string;
  nationality: string;
  profession: string;

  passportNo: string;
  passportType: string;
  passportFirstName: string;
  passportMiddleName: string;
  passportLastName: string;
  passportArabicName: string;
  passportDOB: string;
  passportGender: string;
  passportNationality: string;
  passportIssueDate: string;
  passportExpiryDate: string;
  passportIssuePlace: string | null;

  fatherName: string;
  fatherNameArabic: string;
  fatherITSNo: string;

  grandfatherName: string;
  grandfatherNameArabic: string;
  grandfatherITSNo: string;

  motherName: string;
  motherNameArabic: string;
  motherITSNo: string;

  mothersFatherName: string;
  mothersFatherNameArabic: string;
  mothersFatherITSNo: string;

  remarks: string;

  visaRequired: boolean;
  visaNotRequiredRemark: string;

  isMiqaatApplicant: boolean;

  rotationId: number | null;
  miqaatCode: string | null;
  miqaatName: string | null;
  rotationCode: string | null;
  rotationName: string | null;

  currentStatusCode: string;
  validationErrors: string;
  lastStatusMessage: string;

  certificateFilePath: string | null;
  certificateStatus: string | null;

  visaFee: number;
  currency: string | null;

  batchId: number | null;
  batchNumber: string | null;
  batchStatus: number | null;
  batchGuid: string | null;

  createdOn: string;

  documents: VisaDocument[];
}

export interface ShortlistedVisaApplication extends VisaApplication {
  publicId: string;
  shortlistedAt: string;
  shortlistedBy: number;
}

export interface ShortlistedVisaApplicationResponse {
  success: boolean;
  message: string;
  data: ShortlistedVisaApplication[];
  errors: string[];
}
export interface VisaApplicationResponse {
  success: boolean;
  message: string;
  data: VisaApplication[];
  errors: string[];
}

export interface RoomAllocationApplicant {
  tourRoomAllocationApplicantId:number;
  publicId:string;
  tourRoomAllocationId:number;
  visaApplicationId:number;
  itsNo:string;
  applicantName:string;
  isActive:boolean;
} 

export interface GetRoomAllocationResponse {
  success: boolean;
  message: string;
  data: {
    tourPublicId: string;
    tourName: string;
    tourType: number;
    tourCategory: number;
    tourOperatorName: string;
    noOfApplicants: number;
    arrivalDate: string;
    departureDate: string;
    status: number;
    approvalStatus: number;
    allocateStatus: string;
    roomAllocations: RoomAllocation[];
  };
  errors: string[];
}

export interface SaveRoomAllocationPayload {
  roomAllocations: {
    roomAllocationPublicId: string;
    applicants: {
      visaApplicationId: number;
    }[];
  }[];
}

export interface SaveTourServicesPayload {
  mandatoryServiceIds: number[];
  optionalServices: {
    applicantId: number;
    servicesIds: number[];
  }[];
}

export interface TourServiceItem {
  id: number;
  publicId: string;
  serviceId: number;
  serviceName: string;
  description: string;
  serviceType: string;
  isMandatory: boolean;
  isDefaultChecked: boolean;
  isActive: boolean;
  createdBy: number;
  createdOn: string;
}

export interface ApplicantOptionalService {
  applicantId: number;
  services: TourServiceItem[];
}

export interface GetTourServicesResponse {
  success: boolean;
  message: string;
  data: {
    mandatoryServices: TourServiceItem[];
    optionalServices: ApplicantOptionalService[];
  };
  errors: string[];
}

export interface AtraafDetail {
  ziyaratName: string;
  travelTimeMinutes: string;
  durationHours: string;
  transportType: string;
  optionalFlag: boolean;
}

export interface TourAtraaf {
  atraafId: number;
  publicId: string;
  atraafName: string;
  venueId: number;
  venueName: string;
  minDays: number;
  sortPriority: number;
  canBeDoneMultipleTimes: boolean;
  includeDaily: boolean;
  durationHours: string;
  transportRequired: boolean;
  optionalRoute: boolean;
  lawazimRequired: boolean;
  isActive: boolean;
  detailsCount: number;
  availableDays: number[];
  details: AtraafDetail[];
}

export interface TourAtraafResponse {
  success: boolean;
  message: string;
  data: TourAtraaf[];
  errors: string[];
}

export interface SaveTourAtraafPayload {
  venuePublicId: string;
  venueDate: string;
  atraafPublicIds: string[];
}
export interface AssignedTourAtraaf {
  publicId: string;
  tourPublicId: string;
  tourName: string;

  venuePublicId: string;
  venueName: string;

  atraafPublicId: string;
  atraafName: string;

  venueDate: string;

  assignedBy: number;
  assignedDate: string;
  createdOn: string;
  updatedOn: string | null;
}

export interface TravelSegment {
  sequence: number;

  segmentType: "Arrival" | "InterVenue" | "Departure";

  fromName: string;
  toName: string;

  fromVenuePublicId: string | null;
  toVenuePublicId: string | null;

  startDate: string;
  startTime: string;
  startLabel: string;

  endDate: string;
  endTime: string;
  endLabel: string;
}

export interface AssignedTourAtraafData {
  tourPublicId: string;
  tourName: string;

  assignments: AssignedTourAtraaf[];

  travelSegments: TravelSegment[];
}

export interface AssignedTourAtraafResponse {
  success: boolean;
  message: string;
  data: AssignedTourAtraafData;
  errors: string[];
}

export interface DeleteAssignedTourAtraafResponse {
  success: boolean;
  message: string;
  data: boolean;
  errors: string[];
}

export interface DeleteRoomAllocationResponse {
  success: boolean;
  message: string;
  data: {
    tourPublicId: string;
    tourName: string;
    tourType: number;
    tourCategory: number;
    tourOperatorName: string;
    noOfApplicants: number;
    arrivalDate: string;
    departureDate: string;
    status: number;
    approvalStatus: number;
    allocateStatus: string;
    roomAllocations: RoomAllocation[];
  };
  errors: string[];
}

export interface TourServiceMasterItem {
  tourServiceId: number;
  serviceName: string;
  description: string;
  serviceType: string;
  isMandatory: boolean;
  isDefaultChecked: boolean;
  isActive: boolean;
  createdBy: number;
  updatedBy: number;
  createdAt: string;
  updatedAt: string;
  publicId: string;
}

export interface ShortlistApplicantsPayload {
  visaApplicantIds: number[];
}

export interface DeleteShortlistedApplicantResponse {
  success: boolean;
  message: string;
  data: boolean;
  errors: string[];
}

export interface TourCancellationTier {
  lawazimCancellationTierPublicId: string;
  daysBeforeCheckIn: number;
  basedOn: number;
  penaltyValue: number;
  basedOnDisplayName: string;
}

export interface TourCancellationTiersResponse {
  success: boolean;
  message: string;
  data: {
    tourPublicId: string;
    tourCode: string;
    tourName: string;
    tourCategory: number;
    arrivalDate: string;
    departureDate: string;
    status: number;
    statusName: string;
    approvalStatus: number;
    cancellationTiers: TourCancellationTier[];
  };
  errors: string[];
}

export interface CancelApplicantResponse {
  success: boolean;
  message: string;
  data: boolean;
  errors: string[];
}

export interface AtraafRecommendationDate {
  venueDate: string;
  availableFrom: string;
  availableUntil: string;
  remainingCapacity: number;
  isAssigned: boolean;
}

export interface AtraafRecommendation {
  atraafPublicId: string;
  atraafName: string;
  venuePublicId: string;
  venueName: string;
  capacity: number;
  minDays: number;
  sortPriority: number;
  durationHours: string;
  includeDaily: boolean;
  canBeDoneMultipleTimes: boolean;
  optionalRoute: boolean;
  transportRequired: boolean;
  lawazimRequired: boolean;
  dates: AtraafRecommendationDate[];
}

export interface AtraafRecommendationsResponse {
  success: boolean;
  message: string;
  data: AtraafRecommendation[];
  errors: string[];
}

export interface AssignAtraafsBulkPayload {
  venuePublicId: string;
  venueDate: string;
  atraafPublicIds: string[];
  overrideExisting: boolean;
}

export interface AssignedAtraafBulkResponse {
  success: boolean;
  message: string;
  data: AssignedTourAtraaf[];
  errors: string[];
}

export const getAuthHeader = () => {
  const token = localStorage.getItem("fhims_auth_token");
  return token ? { Authorization: `Bearer ${token}` } : {};
};

export const getTourApproval = async (
  publicId: string
): Promise<TourApprovalResponse> => {
  const res = await axiosInstance.get(`/tours/${publicId}`, {
    headers: getAuthHeader(),
  });

  return res.data;
};

export const getVisaApplicants = async (
  tourPublicId: string,
  params?: VisaApplicantQuery
): Promise<VisaApplicationResponse> => {
  const res = await axiosInstance.get(
    `/tours/${tourPublicId}/visa-applicants`,
    {
      params,
      headers: getAuthHeader(),
    }
  );

  return res.data;
};

export const getRoomAllocations = (
  tourPublicId: string
) =>
  axiosInstance.get<GetRoomAllocationResponse>(
    `/tours/${tourPublicId}/room-allocations`
  );

export const saveRoomAllocations = (
  tourPublicId: string,
  createdBy: number,
  payload: SaveRoomAllocationPayload
) =>
  axiosInstance.post(
    `/tours/${tourPublicId}/room-allocations`,
    payload,
    {
      params: {
        createdBy,
      },
    }
  );

export const saveTourServices = (
  publicId: string,
  createdBy: number,
  payload: SaveTourServicesPayload
) =>
  axiosInstance.post(
    `/tours/${publicId}/services`,
    payload,
    {
      params: { createdBy },
      headers: getAuthHeader(),
    }
  );

export const getTourAtraaf = async (
  tourPublicId: string
): Promise<TourAtraafResponse> => {
  const res = await axiosInstance.get(
    `/tours/${tourPublicId}/atraaf/full-details`,
    {
      headers: getAuthHeader(),
    }
  );

  return res.data;
};

export const saveTourAtraaf = (
  tourPublicId: string,
  payload: SaveTourAtraafPayload
) =>
  axiosInstance.post(
    `/tours/${tourPublicId}/atraafs-assign`,
    payload,
    {
      headers: getAuthHeader(),
    }
  );

export const getAssignedTourAtraaf = async (
  tourPublicId: string
): Promise<AssignedTourAtraafResponse> => {
  const res = await axiosInstance.get(
    `/tours/atraafs/${tourPublicId}`,
    {
      headers: getAuthHeader(),
    }
  );

  return res.data;
};

export const deleteAssignedTourAtraaf = async (
  assignPublicId: string
): Promise<DeleteAssignedTourAtraafResponse> => {
  const res = await axiosInstance.delete(
    `/tours/atraafs/${assignPublicId}`,
    {
      headers: getAuthHeader(),
    }
  );

  return res.data;
};

export const getTourServices = async (
  publicId: string
): Promise<GetTourServicesResponse> => {
  const res = await axiosInstance.get(
    `/tours/${publicId}/services`,
    {
      headers: getAuthHeader(),
    }
  );

  return res.data;
};

export const deleteTourService = async (
  tourPublicId: string,
  servicePublicId: string
): Promise<GetTourServicesResponse> => {
  const res = await axiosInstance.delete(
    `/tours/${tourPublicId}/${servicePublicId}/services`,
    {
      headers: getAuthHeader(),
    }
  );

  return res.data;
};

export const deleteRoomAllocation = async (
  tourPublicId: string,
  roomApplicantPublicId: string
): Promise<DeleteRoomAllocationResponse> => {
  const res = await axiosInstance.delete(
    `/tours/${tourPublicId}/room-allocations/${roomApplicantPublicId}`,
    {
      headers: getAuthHeader(),
    }
  );

  return res.data;
};

export const cancelRoomAllocation = async (
  tourPublicId: string,
  roomAllocationPublicId: string
): Promise<DeleteRoomAllocationResponse> => {
  const res = await axiosInstance.delete(
    `/tours/${tourPublicId}/room-allocations/${roomAllocationPublicId}/cancel`,
    {
      headers: getAuthHeader(),
    }
  );

  return res.data;
};

export const getTourServiceMaster = async (): Promise<TourServiceMasterItem[]> => {
  const res = await axiosInstance.get("/TourService", {
    headers: getAuthHeader(),
  });

  return res.data;
};

export const shortlistApplicants = (
  tourPublicId: string,
  payload: ShortlistApplicantsPayload
) =>
  axiosInstance.post(
    `/tours/${tourPublicId}/shortlist-applicants`,
    payload,
    {
      headers: getAuthHeader(),
    }
  );

export const getShortlistedApplicants = async (
  tourPublicId: string
): Promise<ShortlistedVisaApplicationResponse> => {
  const res = await axiosInstance.get(
    `/tours/${tourPublicId}/shortlist-applicants`,
    {
      headers: getAuthHeader(),
    }
  );

  return res.data;
};

export const deleteShortlistedApplicant = async (
  publicId: string
): Promise<DeleteShortlistedApplicantResponse> => {
  const response = await axiosInstance.delete(
    `/tours/shortlist-applicants/${publicId}`,
    {
      headers: getAuthHeader(),
    }
  );

  return response.data;
};
export const getTourCancellationTiers = async (
  tourPublicId: string
): Promise<TourCancellationTiersResponse> => {
  const res = await axiosInstance.get(
    `/tours/${tourPublicId}/cancellation-tiers`,
    {
      headers: getAuthHeader(),
    }
  );

  return res.data;
};

export const cancelApplicant = async (
  tourPublicId: string,
  applicantPublicId: string
): Promise<CancelApplicantResponse> => {
  const res = await axiosInstance.delete(
    `/tours/${tourPublicId}/Applicant/${applicantPublicId}`,
    {
      headers: getAuthHeader(),
    }
  );

  return res.data;
};

export const getAtraafRecommendations = async (
  tourPublicId: string
): Promise<AtraafRecommendationsResponse> => {
  const res = await axiosInstance.get(
    `/tours/${tourPublicId}/atraafs-recommendations`,
    {
      headers: getAuthHeader(),
    }
  );

  return res.data;
};

export const assignAtraafsBulk = async (
  tourPublicId: string,
  payload: AssignAtraafsBulkPayload
): Promise<AssignedAtraafBulkResponse> => {
  const res = await axiosInstance.post(
    `/tours/${tourPublicId}/atraafs-assign-bulk`,
    payload,
    {
      headers: getAuthHeader(),
    }
  );

  return res.data;
};
